import { Component,ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PwaAppService } from '~/shared';
import { ActivatedRoute } from '@angular/router';

@Component({
    templateUrl: './msg-dialog.component.html',
    styles: [`
        mat-card { margin-bottom: 10px; }
        mat-nav-list a[mat-list-item].full-height /deep/ .mat-list-item {
            height: 100%; margin-bottom: 10px;
        }
        `],

})
export class MsgDialog {

    public title: string;
    public msg: string;
    public positiveAction: any;
    public positiveActionLabel: string;
    public negativeAction: any;
    public negativeActionLabel: string;
    
    public type: MsgDialogType;


    constructor(public dialogRef: MatDialogRef<MsgDialog>, public pwa: PwaAppService, private changeDetectorRef: ChangeDetectorRef ) {
        
        
    }

    public getIcon(): string {
        switch (this.type) {
            case MsgDialogType.Exclamation:
                return "warning";
            case MsgDialogType.Information:
                return "info";
            case MsgDialogType.Confirmation:
                return "";
        }
    }

    public getOkayTxt(): string {

        if (this.type == MsgDialogType.Confirmation) return "Yes";

        return "OKAY";
    }

    public getCancelTxt(): string {

        if (this.type == MsgDialogType.Confirmation) return "No";

        return "CANCEL";
    }

    static isDialogOpen: boolean = false;
    static ref: MatDialogRef<MsgDialog, any>;
    public static policyMemberGuid: any;
    public static shortID: any;
    public static reminder: string;

    public static exclamation(dialog: MatDialog, title: string, message: string, positiveAction: any = null, negativeAction: any = null, policyMemberGuid: any = null, shortId: any = null, reminder: string = null) {
        if (this.isDialogOpen) {
            console.info("Modal Msg dialog already open");
            return;
        }

   
        this.ref = dialog.open(MsgDialog, { disableClose: false });

        MsgDialog.isDialogOpen = true;

        this.ref.componentInstance.changeDetectorRef.markForCheck();

        this.ref.componentInstance.title = title;
        this.ref.componentInstance.msg = message;


        if(positiveAction != null){
            var posObj = JSON.parse(positiveAction);
            this.ref.componentInstance.positiveAction = posObj;
            this.ref.componentInstance.positiveActionLabel = posObj.Label;
        }

        if(negativeAction != null){
            var negObj = JSON.parse(negativeAction);
            this.ref.componentInstance.negativeAction = negObj;
            this.ref.componentInstance.negativeActionLabel = negObj?.Label;
        }

        if(policyMemberGuid != null){
            MsgDialog.policyMemberGuid = policyMemberGuid;
        }

        if(shortId != null){
            MsgDialog.shortID = shortId;
        }

        if(reminder != null){
            MsgDialog.reminder = reminder;
        }

        this.ref.componentInstance.type = MsgDialogType.Exclamation;

        let sub = this.ref.afterClosed().subscribe(x => {
            MsgDialog.isDialogOpen = false;
            this.ref.componentInstance.changeDetectorRef.detach();
            if (sub) sub.unsubscribe();
        });

        
        this.ref.componentInstance.changeDetectorRef.detectChanges(); 
    }


    public positiveActionDo() {
        let dialog = this;

        DAL.Icev0.pwa.UserAttentionAction({pwaAppId: this.pwa.appId
            ,policyMemberGuid: MsgDialog.policyMemberGuid
            ,shortId: MsgDialog.shortID
            ,actionType: this.positiveAction.Type
            ,shortType: this.positiveAction.ShortType
            ,description: this.positiveAction.Action?.toString()
        }).ExecQuery().then(r =>{

            let action = r.Data.OutputParms.positiveActionReturn;
            if(this.positiveAction.Type == 1/*None*/){
                if(action != null){
                    dialog.pwa.UserAttention$.next(MsgDialog.reminder);
                }
                this.dialogRef.close();
            }
    
            if(this.positiveAction.Type == 2/*Redirect*/){
                dialog.pwa.UserAttention$.next(MsgDialog.reminder);
                window.open(action, '_blank');
                this.dialogRef.close();
            }
        })
    }

    public negativeActionDo() {
        let dialog = this;
        
        DAL.Icev0.pwa.UserAttentionAction({pwaAppId: this.pwa.appId
            ,policyMemberGuid: MsgDialog.policyMemberGuid
            ,shortId: MsgDialog.shortID
            ,actionType: this.negativeAction.Type
            ,shortType: this.negativeAction.ShortType
            ,description: this.negativeAction.Action?.toString()
        }).ExecQuery().then(r =>{

            let action = r.Data.OutputParms.positiveActionReturn;
            if(this.negativeAction.Type == 1/*None*/){
                if(action != null){
                    dialog.pwa.UserAttention$.next(MsgDialog.reminder);
                }
                this.dialogRef.close();
            }
            if(this.negativeAction.Type == 2/*Redirect*/){
                window.open(action, '_blank');
                this.dialogRef.close();
            }        
        })
    }

    get isDefaultApp(){
        try{
            var useDefault = (this.pwa?.appId?.toUpperCase() == '5F94C1C5-E512-4D52-A830-0FF2CF6668E2' /*EA ASSIST*/
            || this.pwa?.appId?.toUpperCase() == 'EE6F78C2-DE8B-435F-85AE-BD1B4CED59CD' /*JVC*/
            || this.pwa?.appId?.toUpperCase() == 'AAE12D7A-37B2-4124-82EE-A7F1E6166666' /*ELITE PRO*/
            || this.pwa?.appId?.toUpperCase() == 'AAC5DEA9-198E-44E2-AB37-0942E30CC95F'/*NextPhasVentures*/
            || this.pwa?.appId?.toUpperCase() == 'C41A1369-B50A-413B-9D3C-A5398D53D329'/*Bonitas*/
            || this.pwa?.appId?.toUpperCase() == '32A83A5E-0539-4527-A24A-B2579A1527EC'/*Volkswagen*/);
            return useDefault;
        } catch(e){
            return true;
        }
        
    }

    public static info(dialog: MatDialog, title: string, message: string) {
        
        if (this.isDialogOpen) {
            console.info("Modal Msg dialog already open");
            return;
        }

        this.ref = dialog.open(MsgDialog, { disableClose: false });

        MsgDialog.isDialogOpen = true;

        this.ref.componentInstance.title = title;
        this.ref.componentInstance.msg = message;
        this.ref.componentInstance.type = MsgDialogType.Information;

        let sub = this.ref.afterClosed().subscribe(x => {
            MsgDialog.isDialogOpen = false;
            if (sub) sub.unsubscribe();
        });
    }

    public static confirm(dialog: MatDialog, title: string, message: string): Promise<boolean> {

        return new Promise<boolean>((resolve, reject) => {
            this.ref = dialog.open(MsgDialog, { disableClose: false });

            this.ref.componentInstance.title = title;
            this.ref.componentInstance.msg = message;
            this.ref.componentInstance.type = MsgDialogType.Confirmation;

            this.ref.componentInstance.dialogRef.afterClosed().subscribe(n => {
                resolve(n == "OK");
            });


        });
    }

    public getMsg() {
        // very crude for now... TODO: will eventually fix on the jsDAL Server side
        if (this.msg) {
            if (this.msg.indexOf("Timeout expired") >= 0) {
                return "Your request to the server took too long and timed out. Please check your internet connection and try again.";
            }
            else {
                return this.msg;
            }
        }
    }

}

enum MsgDialogType {
    Exclamation = 10,
    Information = 20,
    Confirmation = 50
}
